<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, useSlots, computed } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import TelaTabelaBase from '@/components/v2/base/TelaTabelaBase/TelaTabelaBase.vue';
import FiltrosBase from '@/components/v2/base/FiltrosBase/FiltrosBase.vue';
import ChipUsuario from '@/components/v2/compostos/ChipUsuario/ChipUsuario.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    filtros: {
        type: [Array, Object],
        required: true
    },
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    }
});

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('tabela-linha-item.'))

);

</script>

<template>

    <TelaTabelaBase
        :disabled="props.disabled"
        :headers="props.headers"
        :dados="props.dados"
    >

        <template #tela-titulo>
            <slot name="tela-titulo"></slot>
        </template>

        <template #tabela-linha-botoes="slotProps">
            <slot name="tabela-linha-botoes" v-bind="slotProps"></slot>
        </template>

        <template
            v-for="name in slotsDeItem"
            #[name]="slotProps"
        >

            <slot :name="name" v-bind="slotProps ?? {}"></slot>

        </template>

        <template #card-header>

            <div class="c-grid">

                <div class="c-grid__toolbar-esquerda">

                     <div class="c-grid__toolbar-cima-esquerda c-filtros">

                        <FiltrosBase :filtros="props.filtros" :disabled="props.disabled"></FiltrosBase>
                    
                    </div>

                    <div
                        v-if="$slots['toolbar-baixo-esquerda']"
                        class="c-grid__toolbar-baixo-esquerda"
                    >
                        <slot name="toolbar-baixo-esquerda"></slot>
                    </div>

                </div>

                <div class="c-grid__toolbar-direita">

                    <div class="c-grid__toolbar-cima-direita c-usuario">

                        <ChipUsuario
                            class="c-chip-usuario"
                            backgroundColor="#e0e0e0"
                            textColor="#000000"
                            size="48px"
                        ></ChipUsuario>

                    </div>


                    <div
                        v-if="$slots['toolbar-baixo-direita']"
                        class="c-grid__toolbar-baixo-direita"
                    >
                        <slot name="toolbar-baixo-direita"></slot>
                    </div>

                </div>

            </div>

        </template>

        <template #card-footer>
            <slot name="card-footer"></slot>
        </template>

        <template #modais>
            <slot name="modais"></slot>
        </template>

    </TelaTabelaBase>

</template>

<style scoped>

.c-grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: max-content;
    grid-template-areas: 
        "filtros direita"
        "baixoEsquerda direita";
    gap: 10px;
}

.c-grid__toolbar-esquerda{
    display: contents;
}

.c-grid__toolbar-direita{
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: max-content;
    gap: 10px;
    grid-area: direita;
}

.c-filtros {
    grid-area: filtros;
}

.c-grid__toolbar-baixo-esquerda {
    grid-area: baixoEsquerda;
}

.c-chip-usuario{
    display: grid;
    justify-content: center;
}

@media (max-width: 768px) {

    .c-grid{
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;
        grid-template-areas: 
            "usuario"
            "filtros "
            "baixoDireita"
            "baixoEsquerda";
        gap: 10px;
    }

    .c-grid__toolbar-esquerda{
        display: contents;
    }

    .c-grid__toolbar-direita{
        display: contents;
    }

    .c-usuario {
        grid-area: usuario;
    }

    .c-filtros {
        grid-area: filtros;
    }

    .c-grid__toolbar-baixo-esquerda {
        grid-area: baixoEsquerda;
    }

    .c-grid__toolbar-baixo-direita {
        grid-area: baixoDireita;
    }

}

</style>
